export class StorageFile {
    name: string = ""; 
    path: string = ""; 
    link: string = ""; 
    size: number = 0; 
    created: string = ""; 
    updated: string = ""; 
}